import { OnboardingDocumentsItem } from 'commons/types/DTO/bank/applications/manage/OnboardingDocumentsItem'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSectionPrimary } from 'ui/components'
import { Table } from 'ui/components/Table'

import { OnboardingDocumentsListProps } from './OnboardingDocumentsList.types'
import { columns } from './columns'

export const OnboardingDocumentsList = ({ application }: OnboardingDocumentsListProps) => {
  const { applicationID, onboardingDocuments } = application

  return (
    <PageSectionPrimary face={'solid'} anchor={'onboarding-documents'} title={'Onboarding Documents'}>
      <Layer rounded shadowed stretch>
        <Table<OnboardingDocumentsItem>
          dataQa={TableDataQa.BP_ONBOARDING_SETUPPING_DOCUMENTS_LIST}
          columns={columns(applicationID)}
          dataSource={onboardingDocuments?.map((item) => ({ item })) ?? []}
        />
      </Layer>
    </PageSectionPrimary>
  )
}
